module.exports = {
  unknown: {
    key: 'unknown',
    label: 'Unknown',
    icon: 'sexGenderUnknown',
  },
  female: {
    key: 'female',
    label: 'Female',
    icon: 'sexGenderFemale',
  },
  male: {
    key: 'male',
    label: 'Male',
    icon: 'sexGenderMale',
  },
  transfemale: {
    key: 'transfemale',
    label: 'Trans Female',
    icon: 'sexGenderTrans',
  },
  transmale: {
    key: 'transmale',
    label: 'Trans Male',
    icon: 'sexGenderTrans',
  },
  other: {
    key: 'other',
    label: 'Other',
    icon: 'sexGenderOther',
  },
};